import styled from 'styled-components';
import { Table as BaseTable } from 'antd';

export const StyledTableItensProcessoSolicitacao = styled(BaseTable)`

  /* Estilos gerais da tabela */
  .ant-table-thead > tr > th {
    font-family: 'Montserrat', sans-serif;
    background-color: #F9F9FB;
    color: #125578;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    border-right: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
    border-top: 1px solid #dee2e6;
  }

  .ant-table-tbody > tr > td {
    color: #333;
    font-family: 'Montserrat', sans-serif;
    text-align: center;
    justify-content: center;
    border: 1px solid #dee2e6;
    padding: 8px;
    font-size: 14px;
  }

  .ant-table-tbody > tr {
    min-height: 48px;
    background-color: #F9F9FB;
  }

  .ant-table-title {
    font-family: 'Montserrat', sans-serif;
    color: #125578;
    font-size: 18px;
    font-weight: bold;
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 1rem;
  }

  .ant-pagination {
    display: flex;
    justify-content: center; /* Centraliza a paginação */
    align-items: center;
    padding: 8px 0;
    background-color: transparent;
  }
`;
